import { reduce } from 'lodash';
import { Puzzle } from './types';
import { MAX_GOAL, MIN_GOAL } from './App';



export const generateRandomPuzzle = (numbersToGuess: number = 6): Puzzle => {
  let validPuzzle: Puzzle | undefined = undefined;
  while (validPuzzle === undefined){
  const targetNumber =  Math.floor(Math.random() * (MAX_GOAL-MIN_GOAL)) + MIN_GOAL;
  const digits: string[] = [];
  while (digits.length < numbersToGuess) {
    const n = `${Math.floor(Math.random() * 9) + 1}`;
    if (digits.filter(d => d === n).length < 2) {
      digits.push(n);
    }
}
console.log('digits',digits);

  let randomCountOp=0
  while (validPuzzle === undefined && randomCountOp<(Math.pow(4,numbersToGuess-1)/2)) {
    randomCountOp++
    const operations = ['+', '-', '*', '/'];
    const randomOps = Array.from({ length: numbersToGuess-1 }, () => operations[Math.floor(Math.random() * operations.length)]);
    console.log('randomOps', randomOps, digits, targetNumber);
    // Randomly add one or two pairs of parentheses
    const numParenthesesPairs = Math.floor(Math.random() * 2) + 1;
    for (let i = 0; i < numParenthesesPairs; i++) {
      const openIndex = Math.floor(Math.random() * (randomOps.length + 1));
      const closeIndex = Math.floor(Math.random() * (randomOps.length - (openIndex+1))) + openIndex + 2;      
      if(closeIndex>openIndex+1){

        randomOps.splice(openIndex, 0, '(');
        randomOps.splice(closeIndex, 0, ')');
      }
    }

    const validSolutions = getValidSolutions(targetNumber, digits, randomOps);
    console.log('validSolutions',validSolutions);
    if (validSolutions.length > 0 && validSolutions.length <= 8) {
      const puzzleId = generatePuzzleId(targetNumber, digits, randomOps);
      console.log('validSolutions', validSolutions);
      validPuzzle = {
        puzzleId,
        operations: randomOps,
        targetNumber,
        digits,
        solutions: validSolutions,
      };
      break;
    }
  }
}
  return (
    validPuzzle ?? { puzzleId: '', targetNumber: 0, digits: [], solutions: [] }
  );
};

export const generatePuzzleId = (targetNumber: number, digits: string[], operations: string[]): string => {
  return `${targetNumber}@${digits.join('_')}@${operations.join('_')}`;
};

export const decodePuzzleId = (id: string): Puzzle => {
  try {
    
    const [targetStr, digitsStr, opsStr] = id.split('@');
    const targetNumber = parseInt(targetStr, 10);
    const digits = digitsStr.split('_');
    const operations = opsStr.split('_');
    
    // Validate that we have between 4-6 digits
    if (digits.length < 4 || digits.length > 6) {
      throw new Error('Invalid puzzle ID');
    }
    
    const solutions = getValidSolutions(targetNumber, digits, operations);
    console.log('decoded', targetNumber, digits, operations,solutions);
    return { puzzleId: id, targetNumber, digits, operations, solutions };
  } catch {
    return { puzzleId: id, targetNumber: 0, digits: [], operations: [], solutions: [] };
  }
};

export function getValidSolutions(
  targetNumber: number,
  digits: string[],
  randomOps: string[]
): string[] {
  const permutations = generatePermutations(digits);

  return reduce<string[], string[]>(
    permutations,
    (res, perm) => {
      const expression = interleaveWithOps(perm, randomOps);
      const calcResult = evaluateExpression(expression) ;
      console.log('expression',expression,"= ",calcResult,"target:",targetNumber);
      const isValid=( calcResult===targetNumber && targetNumber<=MAX_GOAL && targetNumber>=MIN_GOAL)

      if (isValid) {
        res.push(expression);
      }
      return res;
    },
    []
  );
}

export function generatePermutations(array: string[]): string[][] {
  if (array.length <= 1) return [array];
  const permutations: string[][] = [];
  for (let i = 0; i < array.length; i++) {
    const currentNum = array[i];
    const remainingNums = array.slice(0, i).concat(array.slice(i + 1));
    const remainingPerms = generatePermutations(remainingNums);
    for (const perm of remainingPerms) {
      permutations.push([currentNum, ...perm]);
    }
  }
  return permutations;
}

export function evaluateExpression(expression: string): number {
  try {
    // eslint-disable-next-line no-eval
    return eval(expression);
  } catch {
    return NaN;
  }
}

export const interleaveWithOps = (numbers: string[], ops: string[]): string => {
  let expression = '';
  let numIndex = 0;
  let opIndex = 0;

  while (numIndex < numbers.length || opIndex < ops.length) {
    if (opIndex < ops.length && ops[opIndex] === '(') {
      expression += ops[opIndex++];
    }
    if (numIndex < numbers.length) {
      expression += numbers[numIndex++];
    }

    if (opIndex < ops.length && ops[opIndex] === ')') {
      expression += ops[opIndex++];
    }
    if (opIndex < ops.length && ops[opIndex] !== '(' && ops[opIndex] !== ')') {
      expression += ops[opIndex++];
    }
   
  }
  

  return expression;
};

export const getSolutionDigitsFromSolution=(solution:string):string[] => {

  return solution
  ?.split("")
  .filter((c) => c.match(/\d/));
}

const KEY = "some-weird-static-key";

export function obfuscate(s: string): string {
  return btoa([...s].map((c, i) =>
    String.fromCharCode(c.charCodeAt(0) ^ KEY.charCodeAt(i % KEY.length))
  ).join(""));
}

export function unobfuscate(s: string): string|undefined {
  try{
    const t = atob(s);
    return [...t].map((c, i) =>
      String.fromCharCode(c.charCodeAt(0) ^ KEY.charCodeAt(i % KEY.length))
  ).join("");
} catch(error){
  return undefined
}
}